import { patchState, signalStore, withHooks, withMethods } from "@ngrx/signals";
import { setAllEntities, withEntities } from "@ngrx/signals/entities";
import { setFulfilled, setPending, withRequestStatus } from "../extensions/request-status.feature";
import { inject } from "@angular/core";
import { rxMethod } from "@ngrx/signals/rxjs-interop";
import { pipe, switchMap, tap } from "rxjs";
import { OfferGenreViewModel } from "@playcharge/common/models/backend/offers/offer-genre-view-model";
import { ApiOfferGenresService } from "../../services/api-offer-genres.service";

export type OfferGenresStore = InstanceType<typeof OfferGenresStore>;

export const OfferGenresStore = signalStore(
    { providedIn: "root" },
    withEntities<OfferGenreViewModel>(),
    withRequestStatus(),
    withMethods((store, apiOfferGenresService = inject(ApiOfferGenresService)) => ({
        loadGenres: rxMethod<void>(
            pipe(
                tap(() => patchState(store, setPending())),
                switchMap(() => {
                    return apiOfferGenresService.getAll().pipe(
                        tap((categories) => {
                            patchState(store, setAllEntities(categories));
                            patchState(store, setFulfilled());
                        }),
                    );
                }),
            ),
        ),
    })),
    withHooks((store) => ({
        onInit: () => {
            store.loadGenres();
        },
    })),
);
